/* eslint-disable @typescript-eslint/no-unused-vars */
import { Checkbox } from '@lt/components';
import { useTranslation } from '@lt/localization';
import React from 'react';
import styled from 'styled-components';
import { scrollToElement } from 'src/utils/domUtils';
import type { PropsFromRedux } from '.';
import { OPERATORS, TEST_ID_FLIGHT_CHANGE_WARNING_CHECKBOX } from './constants';
import { FLIGHT_LIST_ID } from '../../../containers/Flights/FlightsList/constants';

const FlightChangeWarning = ({
  filterByBiblioGlobus,
  applyFilters,
  clearFilters,
  isMobile,
}: PropsFromRedux): JSX.Element => {
  const { t } = useTranslation();
  const handleCheckboxClick = () => {
    if (!filterByBiblioGlobus?.selected) {
      const bgFilter = { ...filterByBiblioGlobus, selected: true };
      applyFilters({ path: OPERATORS, diff: bgFilter });
    } else {
      clearFilters(OPERATORS);
    }
    if (isMobile) scrollToElement(document.getElementById(FLIGHT_LIST_ID));
  };
  return (
    <Background>
      <Wrapper>
        <Title>{t('checkout.flight.changeWarningTitle')}</Title>
        <Text>{t('checkout.flight.changeWarningText')}</Text>
        <StyledCheckbox
          checked={Boolean(filterByBiblioGlobus?.selected)}
          onChange={handleCheckboxClick}
          data-testid={TEST_ID_FLIGHT_CHANGE_WARNING_CHECKBOX}
        >
          <StyledCheckboxText>
            {t('checkout.flight.changeWarningCheckbox')}
          </StyledCheckboxText>
        </StyledCheckbox>
      </Wrapper>
    </Background>
  );
};

const Background = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(255, 255, 255, 0.8);
  user-select: none;
`;

const Wrapper = styled.div`
  background: #f3f2e8;
  padding: 24px;
  border-radius: 60px;

  text-align: center;

  max-width: 292px;
  max-height: 251px;

  > * + * {
    margin-top: 8px;
  }
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
`;

const Text = styled.div`
  font-size: 14px;
`;

const StyledCheckbox = styled(Checkbox)`
  font-size: 14px;
  color: #4d4d4d;
  padding: 4px;
  align-items: center;

  user-select: auto;
`;

const StyledCheckboxText = styled.div`
  height: 18px;
`;

export default FlightChangeWarning;
